import React, { memo, useMemo } from "react";
import { Box } from "app/components/common";
import FastImage from "react-native-fast-image";
import EmptyPicture from "./EmptyPicture";
import normalize from "app/utils/normalize";

const PICTURE_SIZE = normalize(30);

interface Props {
  imageUrl: string;
  name: string | undefined;
  style: any;
  pictureSize: number;
}

const PictureName = ({
  imageUrl = "",
  style = {},
  pictureSize = PICTURE_SIZE,
  name = "",
}: Props) => {
  const source = useMemo(() => {
    return {
      uri: imageUrl,
    };
  }, [imageUrl]);

  const styleImage = useMemo(() => {
    return [
      {
        width: pictureSize,
        height: pictureSize,
        borderRadius: pictureSize / 2,
      },
      style,
    ];
  }, []);

  if (!!imageUrl) return <FastImage source={source} style={styleImage} />;

  return (
    <EmptyPicture
      firstName={name}
      size={pictureSize}
      stylePicture={styleImage}
      variant={pictureSize < normalize(35) ? "l5-bold" : "l8-bold"}
    />
  );
};

export default memo(PictureName);
